import { type IConfig } from './types';

export const INITIAL_CONFIG: IConfig = {
  distTag: '',
  gdpr: 0,
  gdprConsent: '',
  userToken: '',
  hdStream: false,
  excludePreroll: false,
  newTealiumSetup: false,
  ttag: '',
};
